import { SelectProps } from 'antd'
import { Select } from 'components/atoms'
import { IClinicRoom, IOptionItem } from 'interfaces'
import useClinicOptionRooms from 'pages/patientReceive/logic/useClinicOptionRooms'
import { useEffect } from 'react'

interface IProps extends SelectProps<any, any> {
  title?: string
  required?: boolean
  className?: string
  preventInput?: boolean
  defaultValue?: number
  options?: Array<IOptionItem>
  roomSelected?: IClinicRoom
}

const SelectRoom = (props: IProps) => {
  const { title, defaultValue, options, roomSelected, ...resProps } = props
  const { getClinicRooms, optionRooms } = useClinicOptionRooms(!options)

  useEffect(() => {
    if (!options) {
      getClinicRooms()
    }
  }, [options])

  return (
    <Select
      showArrow
      showDescription
      title={title}
      placeholder="please-choose-info"
      options={options || optionRooms}
      filterOption={false}
      value={roomSelected?.id}
      {...resProps}
    />
  )
}

export default SelectRoom
